import { TransmissionRunEntity } from 'src/store/transmission-run/transmission-run.model';
import { PrdProcessingState } from './pilot-view-model';

export class TransmissionRunViewModel implements TransmissionRunEntity {
  public id?: string | undefined;
  public airCarrierId: string;
  public processingState?: PrdProcessingState | undefined;
  public requestedDate?: Date | undefined;
  public queuedDate?: Date | undefined;
  public processedDate?: Date | undefined;

  constructor(transmissionRun: TransmissionRunEntity) {
    Object.assign(this, transmissionRun);
  }
}
